"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.START_ZOOM_LEVEL = exports.MIN_ZOOM_LEVEL = exports.MAX_ZOOM_LEVEL = void 0;
exports.imageZoomBinding = imageZoomBinding;
exports.MAX_ZOOM_LEVEL = 14;
exports.MIN_ZOOM_LEVEL = 1;
exports.START_ZOOM_LEVEL = 1;
function imageZoomBinding(dc, evt) {
    var startZoom = dc.state.zoom || exports.START_ZOOM_LEVEL;
    var delta = evt.delta;
    var currentZoom = startZoom * delta;
    if (currentZoom < exports.MIN_ZOOM_LEVEL) {
        currentZoom = exports.MIN_ZOOM_LEVEL;
    }
    else if (currentZoom > exports.MAX_ZOOM_LEVEL) {
        currentZoom = exports.MAX_ZOOM_LEVEL;
    }
    currentZoom = Math.round(currentZoom * 100) / 100;
    if (currentZoom === startZoom) {
        return;
    }
    var mousePoint = evt.center;
    if (mousePoint != null) {
        var currentX = dc.state.centerX;
        var currentY = dc.state.centerY;
        var diffX = mousePoint.x - dc.state.centerX;
        var nextX = diffX * delta;
        var diffY = mousePoint.y - dc.state.centerY;
        var nextY = diffY * delta;
        dc.state.setZoom(currentZoom, currentX + nextX - diffX, currentY + nextY - diffY);
    }
    else {
        dc.state.setZoom(currentZoom);
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
}
//# sourceMappingURL=image.zoom.binding.js.map